'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import { Text } from 'foundations-components/components/Text';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import StorefrontHeader from 'marketplace-ui-common/storefront/components/StorefrontHeader';
import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useSelector } from 'react-redux';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getIsPublic } from '../../selectors/auth';
import { getConnectedAppsUrl } from '../../utils/urls';
import SearchSelect from './search/SearchSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = ({
  appIntegrations,
  isAdminPreview,
  isCustomer,
  onSearchAppSelect,
  onSearchCategoryV2Select,
  onSearchClear,
  onSearchFilterSelect,
  onSearchSubmit,
  searchValue,
  trackInteraction
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const isPublicApp = useSelector(getIsPublic);
  const onStickyChange = useCallback(evt => {
    setIsSticky(evt.target.value);
  }, []);
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.MD]: false
    }
  });
  const searchInputSize = useMemo(() => {
    if (!isMobileView && !isSticky) {
      return 'xl';
    }
    return 'default';
  }, [isMobileView, isSticky]);
  const renderedTitle = /*#__PURE__*/_jsx(UIRouterLink, {
    to: "/",
    use: "unstyled",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h2",
      color: "text-core-on-fill-default",
      marginBlockEnd: "400",
      textAlign: "center",
      typography: "heading-600",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.header.headingText"
      })
    })
  });
  const renderedButtonRow = useMemo(() => /*#__PURE__*/_jsxs(UIButtonWrapper, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-selenium-id": "manage-apps-button",
      disabled: isAdminPreview,
      href: getConnectedAppsUrl(isCustomer),
      onClick: () => {
        trackInteraction('click manage apps button');
      },
      size: "extra-small",
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.header.manageButtonText"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      disabled: isAdminPreview,
      external: true,
      href: "https://developers.hubspot.com",
      iconProps: {
        className: 'hidden'
      },
      onClick: () => {
        trackInteraction('click build button');
      },
      size: "extra-small",
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.header.buildButtonText"
      })
    })]
  }), [isAdminPreview, isCustomer, trackInteraction]);
  return /*#__PURE__*/_jsx(StorefrontHeader, {
    collapsedTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.detail.header.rootBreadcrumbLinkText"
    }),
    color: "blue",
    onStickyChange: onStickyChange,
    renderedButtonRow: isPublicApp ? null : renderedButtonRow,
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.header.subheadingText"
    }),
    testId: "storefront-header",
    title: renderedTitle,
    ungatedMobile: true,
    children: /*#__PURE__*/_jsx(SearchSelect, {
      appIntegrations: appIntegrations,
      inputSize: searchInputSize,
      isSticky: isSticky,
      onAppSelect: onSearchAppSelect,
      onCategoryV2Select: onSearchCategoryV2Select,
      onClear: onSearchClear,
      onFilterSelect: onSearchFilterSelect,
      onSubmit: onSearchSubmit,
      readOnly: isAdminPreview,
      searchValue: searchValue
    })
  });
};
Header.propTypes = {
  appIntegrations: ImmutablePropTypes.orderedSet.isRequired,
  isAdminPreview: PropTypes.bool,
  isCustomer: PropTypes.bool.isRequired,
  onSearchAppSelect: PropTypes.func.isRequired,
  onSearchCategoryV2Select: PropTypes.func.isRequired,
  onSearchClear: PropTypes.func.isRequired,
  onSearchFilterSelect: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  trackInteraction: PropTypes.func.isRequired
};
export default Header;